import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { withStyles } from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';

const styles = theme => ({
    root: {
        margin: theme.spacing(8),
        padding: theme.spacing(8),
        border: theme.youwell.borders.dim,

        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(7, 5),
            padding: theme.spacing(7, 5),
        },

        [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(6, 2),
            padding: theme.spacing(6, 2),
        },
    },
    text: {
        color: theme.youwell.colors.secondary,
    },
});

class InfoMessage extends React.Component {
    render() {
        const {
            classes, translate, message, messageKey,
        } = this.props;

        if (!message && !messageKey) {
            return null;
        }

        return (
            <div className={classes.root}>
                <Typography align="center" display="block" className={classes.text}>
                    {message}
                    {messageKey && translate(messageKey)}
                </Typography>
            </div>
        );
    }
}

InfoMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    messageKey: PropTypes.string,
    message: PropTypes.string,
};

InfoMessage.defaultProps = {
    message: null,
    messageKey: null,
};


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(InfoMessage));
